<template>
  <section class="no-hotel-results" role="status">
    <div class="empty-heading">
      <div class="empty-icon" aria-hidden="true">
        <i class="iconfont icon-ai-stars" style="font-size: 32px;position: relative;top: -2px"/>
      </div>
      <div>
        <h2>我暂时没找到符合全部条件的酒店</h2>
        <p>{{ description }}</p>
      </div>
    </div>
    <div v-if="tags.length" class="recognized-conditions">
      <strong>已识别的搜索条件</strong>
      <span v-for="(tag, index) in tags" :key="index" class="condition-tag">
        <i class="iconfont icon-condition-success" aria-hidden="true" style="font-size: 10px"></i>
        <span>{{ tag }}</span>
      </span>
    </div>
    <div class="adjustment-tips">
      <ul class="tip_content" v-if="tips && tips.length">
        <li>
          <h3 v-for="(item, index) in tips" :key="index" style="color: #29354a;font-size: 14px">{{ item }}</h3>
        </li>
      </ul>
      <p>请直接修改上方需求描述，然后再次点击AI搜索。</p>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    tags: {type: Array, default: () => []},
    location: {type: String, default: ''},
    tips: {type: Array, default: () => []}
  },
  computed: {
    description () {
      return this.location
        ? '我搜索了' + this.location + '附近的酒店，但暂时没有找到同时满足全部需求的可售结果。'
        : '暂时没有找到同时满足全部需求的可售结果，你可以调整搜索条件后再试一次。'
    }
  }
}
</script>

<style scoped>
.no-hotel-results {
  padding: 16px 24px 10px;
  color: #39465e;
  font-family: '苹方', 'PingFang SC', sans-serif;
}

.no-hotel-results :not(i) {
  font-family: '苹方', 'PingFang SC', sans-serif !important;
}

.empty-heading {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-bottom: 28px;
}

.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #edf2ff;
  color: #2853ff;
  font-size: 30px;
}

h2 {
  margin: 0 0 8px;
  color: #29354a;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
}

.empty-heading p {
  margin: 0;
  color: #7383a0;
  font-size: 13px;
  line-height: 22px;
}

.recognized-conditions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 16px;
  border: 1px solid #dfe6f5;
  border-radius: 7px;
  background: #fafbfe;
}

.recognized-conditions strong {
  margin-right: 6px;
  font-size: 12px;
  font-weight: 600;
}

.condition-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border: 1px solid #cceee2;
  border-radius: 20px;
  background: #edf9f5;
  color: #1f9871;
  font-size: 11px;
  line-height: 16px;
  overflow-wrap: anywhere;
  max-width: 100%;
}

.adjustment-tips {
  margin-top: 18px;
}

h3 {
  margin: 0 0 7px;
  font-size: 13px;
  line-height: 22px;
  font-weight: 600;
}

ul {
  margin: 0 0 10px;
  padding-left: 20px;
  list-style: disc;
}

li {
  color: #687b9b;
  font-size: 12px;
  line-height: 23px;
}

li::marker {
  color: #9aaaca;
}

.adjustment-tips p {
  margin: 0;
  color: #8291ab;
  font-size: 12px;
  line-height: 20px;
}

@media (max-width: 650px) {
  .no-hotel-results {
    padding: 12px 4px;
  }

  .empty-heading {
    gap: 12px;
    align-items: flex-start;
  }

  h2 {
    font-size: 20px;
    line-height: 28px;
  }

  .recognized-conditions {
    padding: 12px;
  }
}

.tip_content li::marker {
  color: #29354a;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/smartHotelSearch/NoHotelResults.vue